import { claimMining_2, getUserBalance } from '../../../Services/Requests';

export class ClaimMiningService {
  static async claim(miningId: number) {
    try {
      const response = await claimMining_2(miningId);
      
      // Обновляем баланс с анимацией после успешного клейма
      await getUserBalance(true);
      
      return response;
    } catch (error) {
      console.error("Ошибка при сборе майнинга:", error);
      throw error;
    }
  }
}
